import React from 'react';
import { Button, Icon } from 'antd';
import cn from 'classnames';
import styles from './index.module.scss';

const RemoveFileBtn = ({ onClick, className }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    onClick();
  };

  return (
    <Button className={cn(styles.root, className)} onClick={handleClick}>
      <Icon type="close-circle" theme="twoTone" twoToneColor="#c5c5c5" />
    </Button>
  );
};

export default RemoveFileBtn;
